/**
 * @generated SignedSource<<28181428f0356be453c7fc8e2f83f5e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MeetingRecordingVisibility = "PRIVATE" | "PUBLIC" | "WORKSPACE";
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
import { FragmentRefs } from "relay-runtime";
export type ShareMeetingModal_note$data = {
  readonly account: {
    readonly allowPublicRecap: boolean;
  };
  readonly createdAt: string | null;
  readonly eventEnd: string | null;
  readonly eventStart: string | null;
  readonly hasMeetingRecordings: boolean;
  readonly id: string;
  readonly meetingRecordingLink: {
    readonly id: string;
    readonly visibility: MeetingRecordingVisibility;
  };
  readonly stream: {
    readonly id: string;
    readonly type: NoteStreamType;
    readonly " $fragmentSpreads": FragmentRefs<"hooksAutomations_useAnySendAutomationsEnabled_stream">;
  };
  readonly title: string;
  readonly viewerCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"SendNotesModal_note" | "ShareMeetingModal_postedChannels" | "ShareMeetingModal_sharedWith" | "ShareRequests_noteAccessRequests" | "useCopyMeetingLink_note">;
  readonly " $fragmentType": "ShareMeetingModal_note";
};
export type ShareMeetingModal_note$key = {
  readonly " $data"?: ShareMeetingModal_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShareMeetingModal_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShareMeetingModal_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasMeetingRecordings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "hooksAutomations_useAnySendAutomationsEnabled_stream"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecordingLink",
      "kind": "LinkedField",
      "name": "meetingRecordingLink",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "visibility",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowPublicRecap",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SendNotesModal_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShareMeetingModal_sharedWith"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShareMeetingModal_postedChannels"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShareRequests_noteAccessRequests"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCopyMeetingLink_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "d10e78305488df8960d020349c265119";

export default node;
